<div *ngIf="interface.type == 'default'" class="bh-block">
    <h2 class="bh-block-title">Award-Winning Program</h2>
    <p class="bh-block-subtitle">1,000,000+ teachers, parents, and students use ArgoPrep materials to help boost student scores. It’s your turn now!</p>
    <div class="bh-block-list">
        <ng-container *ngFor="let award of interface.list | random; let f = index">
            <div class="bh-award">
                <img ngSrc="{{award.thumbnail.src}}" alt="{{award.alt}}" width="96" height="96">
                <p>{{award.title}}</p>
            </div>
        </ng-container>
    </div>
</div>

<div *ngIf="interface.type == 'store'" class="bh-block bh-block-awards-store">
    <div class="bh-block-list">
        <ng-container *ngFor="let award of interface.list | random | slice:0:6; let f = index">
            <div class="bh-award">
                <img ngSrc="{{award.thumbnail.src}}" alt="{{award.alt}}" width="56" height="56">
                <p>{{award.title}}</p>
            </div>
        </ng-container>
    </div>
    <p class="bh-block-text">ArgoPrep is a recipient of the prestigious Mom’s Choice Award. ArgoPrep also received the 2019 Seal of Approval from Homeschool.com for our award-winning workbooks.ArgoPrep was awarded the 2019 National Parenting Products Award and a Gold Medal Parent’s Choice Award.</p>
</div>
